// extracted by mini-css-extract-plugin
export var breadcrumbs = "breadcrumbs__FI_F";
export var faq = "faq__W5sC";
export var faqText = "faqText__mJ1g";
export var questionMark = "questionMark__dxu4";